import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from '../../models/user';
import { MatDialog } from "@angular/material/dialog";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_MSG } from '../../shared/errorMessages';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('lform') loginFormDirective;
  loginForm: FormGroup;
  isLoading: boolean = false;
  passwordIsActive: boolean = false;
  VERSION: string = "2.5.80"; //TODO: get version from package json old
  user: User;
  formErrors = {
    'email': '',
    'password': ''
  };
  validationMessages = {
    'email': {
      'required': 'Por favor ingrese su dirección de correo electrónico'
    },
    'password': {
      'required': 'Por favor ingrese su contraseña'
    }
  };

  constructor(private fb: FormBuilder, private authServ: AuthService,
    private matDialog: MatDialog, private router: Router,
    private _snackBar: MatSnackBar) {

    this.createForm();
  }

  ngOnInit(): void {
  }

  createForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    this.loginForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.onValueChanged(); // (re)set form validation messages now
  }

  onValueChanged(data?: any) {
    if (!this.loginForm) { return; }
    const form = this.loginForm;
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      }
    }
  }

  openDialog() {
    this.matDialog.open(ForgotPasswordComponent, {
      width: '400px',
      data: {}
    });
  }

  login() {
    this.user = this.loginForm.value;
    this.isLoading = true;
    this.authServ.login(this.user.email, this.user.password)
      .then((response) => {
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        this._snackBar.open(ERROR_MSG[error.code === 101 ? 101.1 : error.code], null, {
          duration: 3000,
        });
      });
  }

}
